module.exports = __webpack_public_path__ + "/images/shop/icon/accordion_arrow.svg";